import { lazy } from 'react';
import ProtectedRoute from '../../../core/accessControl/ProtectedRoute';
import Lock from '../../../core/components/organism/Lock';
import Template from '../../../core/templates/baseApp';
import CourseTemplate from '../../../core/templates/courses';
import RevisionTemplate from '../../../core/templates/revision';
import EssayInit from '../pages/Essay';
import EssayWrite from '../pages/Essay/writing';
import RegularCourses from '../pages/cursosRegulares';
import Home from '../pages/index';
import RevisionExamFeedback from '../pages/Revision/Feedback';
import RevisionExercises from '../pages/Revision/Exercises';

//import CourseExercise from '../pages/Exercise';

// const CoursesListPage = lazy(() => import('../pages/RegularCoursesList'));
const CourseLandingPage = lazy(() => import('../pages/CourseLanding'));
const ComplementaryCoursesListPage = lazy(
  () => import('../pages/ComplementaryCoursesList'),
);
const RevisionExam = lazy(() => import('../../Courses/pages/Revision/Exam'));
const RevisionHomePage = lazy(
  () => import('../../Courses/pages/Revision/Home'),
);

export const CoursesRoutes = [
  {
    path: '',
    element: (
      <Template>
        <RegularCourses />
      </Template>
    ),
  },
  {
    path: 'regulares',
    element: (
      <Template>
        <RegularCourses />
      </Template>
    ),
  },
  {
    path: 'complementares',
    element: (
      <Template>
        <ComplementaryCoursesListPage />
      </Template>
    ),
  },
  {
    path: ':slug/detalhes',
    element: (
      <Template>
        <CourseLandingPage />
      </Template>
    ),
  },
  {
    path: ':slug/redacao/inicio',
    element: (
      <CourseTemplate>
        <EssayInit />
      </CourseTemplate>
    ),
  },
  {
    path: ':slug/redacao/escrevendo',
    element: (
      <CourseTemplate>
        <EssayWrite />
      </CourseTemplate>
    ),
  },
  {
    path: ':slug',
    element: (
      <ProtectedRoute
        moduleFromParam="slug"
        customLock={
          <CourseTemplate isLocked={true}>
            <Lock isCourse={true} />
          </CourseTemplate>
        }
        element={
          <CourseTemplate>
            <Home />
          </CourseTemplate>
        }
      />
    ),
  },
  {
    path: ':slug/revisao',
    element: (
      <RevisionTemplate>
        <RevisionHomePage />
      </RevisionTemplate>
    ),
  },
  {
    path: ':slug/revisao/exam/:id',
    element: (
      <RevisionTemplate>
        <RevisionExam />
      </RevisionTemplate>
    ),
  },
  {
    path: ':slug/revisao/gabarito/:id',
    element: (
      <RevisionTemplate>
        <RevisionExamFeedback />
      </RevisionTemplate>
    ),
  },
  {
    path: ':slug/revisao/exercicios/:id',
    element: (
      <RevisionTemplate>
        <RevisionExercises />
      </RevisionTemplate>
    ),
  },
];
